import {
  faCaretDown,
  faCaretUp,
  faInfoCircle,
  faLock,
  faLockOpen,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  changeFormulaTypeFromDays,
  changeFormulaTypeFromGranularToRaw,
  formulaTotalChange,
  lockFormulaByFormulaId,
  removeFormulaFromSection,
} from "../../actions/formulaAction";
import AddHerbPopup from "../../pages/CustomFormulaBuilder/AddHerbPopup";
import HerbItem from "../HerbItem";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
const SuntenFormula = ({
  rawGramPerDayBeforeConversion,
  formula,
  isRawType,
  isOuterLocked,
}) => {
  const [showAddHerb, setShowAddHerb] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);

  const [isTotalChanged, setIsTotalChanged] = useState(false);
  const [totalDosage, setTotalDosage] = useState(formula.formulaDosage);
  const [canEditPercentage, setCanEditPercentage] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOuterLocked) {
      dispatch(lockFormulaByFormulaId(formula.formulaId, false));
    }
  }, [isOuterLocked, dispatch]);

  useEffect(() => {
    setIsTotalChanged(true);
    setTotalDosage(formula.formulaDosage);
  }, [formula.formulaDosage]);

  useEffect(() => {
    let herbGreaterThanZero = formula?.formulaHerbs.filter((x) => x.dosage > 0);

    setCanEditPercentage(herbGreaterThanZero.length >= 2);
  }, formula?.formulaHerbs);
  const CustomTooltip = () => (
    <div className="custom-tooltip">
      Formulas marked "Sun Ten Patented" are pre-mixed and cooked together, so
      ingredients cannot be modified. If you select a non-patented formula, you
      can adjust its individual ingredients.
    </div>
  );
  return (
    <div className="item-wrapper">
      <div className={`delete-formula  `}>
        <FontAwesomeIcon
          icon={faTimesCircle}
          style={{
            cursor: isRawType
              ? "pointer"
              : rawGramPerDayBeforeConversion != null && !isRawType
              ? "initail"
              : "pointer",
            opacity: isRawType
              ? 1
              : rawGramPerDayBeforeConversion != null && !isRawType
              ? 0
              : 1,
          }}
          onClick={() => {
            if (
              isRawType ||
              (!isRawType && rawGramPerDayBeforeConversion == null)
            ) {
              if (!isRawType) {
                dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
                dispatch(removeFormulaFromSection(formula.formulaId));
                dispatch(changeFormulaTypeFromDays(false, 1));
              } else {
                dispatch(removeFormulaFromSection(formula.formulaId));
              }
            }
          }}
        />
      </div>
      <div
        className={`single-herb-section mt-2 ${
          formula.isLocked ? "locked" : ""
        }`}
      >
        {showAddHerb && (
          <AddHerbPopup
            showPopup={showAddHerb}
            closePopup={() => setShowAddHerb(false)}
            formulaId={formula.formulaId}
          />
        )}

        <div className={`${isExpanded ? "expanded" : "collapsed"}`}>
          <table className="table sunten-formula">
            <thead>
              <tr className="head">
                <th></th>
                <th className="formula-name">
                  <div className="d-flex align-items-center">
                    {formula.formulaName.split("-")[0]}
                    <span className="formula-sub-name ml-1">
                      -{formula.formulaName.split("-")[1]}
                    </span>
                    <div style={{ marginLeft: "5px", cursor: "pointer" }}>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 200, hide: 100 }}
                        overlay={
                          <Tooltip id="simple-tooltip">
                            <p style={{ textAlign: "left" }}>
                              Formulas marked "Sun Ten Patented" are pre-mixed
                              and cooked together, so ingredients cannot be
                              modified. If you select a non-patented formula,
                              you can adjust its individual ingredients.
                            </p>
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faInfoCircle} />
                      </OverlayTrigger>
                    </div>
                    <img
                      width={50}
                      height={50}
                      src="https://sunten.com/cdn/shop/files/A3470_236x236.jpg?v=1694809915"
                      alt="placeholder"
                    />
                  </div>
                </th>
                <th className="text-right pr-5">DOSAGE (G)</th>
                <th className="text-right">DOSAGE (%)</th>
                {!isRawType && <th className="text-right">HERB RATIO</th>}
                {!isRawType && <th className="text-right">PRICE</th>}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {formula.formulaHerbs
                .filter((x) => !x.isAdditional && !x.isModification)
                .map((herb) => (
                  <HerbItem
                    isSuntenFormula={true}
                    canEditPercentage={canEditPercentage}
                    rawGramPerDayBeforeConversion={
                      rawGramPerDayBeforeConversion
                    }
                    isRawType={isRawType}
                    herb={herb}
                    key={herb.id}
                    totalDosage={formula.formulaDosage}
                    formulaId={formula.formulaId}
                    isLocked={formula.isLocked || isOuterLocked}
                    isOuterLocked={isOuterLocked}
                  />
                ))}

              <tr className="total-section">
                <td></td>
                <td>TOTAL GRAMS FOR THIS FORMULA:</td>
                <td className={`text-right pr-5`}>
                  {true ? (
                    `${formula.formulaDosage.toLocaleString("en-US", {
                      maximumFractionDigits: 1,
                      minimumFractionDigits: 1,
                    })} grams`
                  ) : (
                    <div
                      className={`d-flex align-items-center justify-content-end mr-1 ${
                        isOuterLocked && "outer-locked"
                      }`}
                    >
                      <button
                        className={`lock-btn ${formula.isLocked && "locked"} ${
                          isOuterLocked && "outer-locked"
                        }`}
                        type="button"
                        onClick={() => {
                          dispatch(
                            lockFormulaByFormulaId(
                              formula.formulaId,
                              !formula.isLocked
                            )
                          );
                        }}
                      >
                        <FontAwesomeIcon
                          icon={formula.isLocked ? faLock : faLockOpen}
                        />
                      </button>
                      <div
                        className={` number-field mr-2  ${
                          formula.isLocked && "outer-locked"
                        }`}
                      >
                        <input
                          type="number"
                          min="0"
                          step="any"
                          value={totalDosage}
                          onChange={(e) => setTotalDosage(e.target.value)}
                          onBlur={(e) =>
                            dispatch(
                              formulaTotalChange(
                                formula.formulaId,
                                parseFloat(e.target.value)
                              )
                            )
                          }
                        />
                        <div>
                          <div
                            className="icon"
                            onClick={() => {
                              dispatch(
                                formulaTotalChange(
                                  formula.formulaId,
                                  formula.formulaDosage +
                                    (isTotalChanged ? 0.5 : 1)
                                )
                              );
                              setIsTotalChanged(false);
                            }}
                          >
                            <FontAwesomeIcon icon={faCaretUp} />
                          </div>
                          <div
                            className="icon"
                            onClick={() =>
                              parseFloat(formula.formulaDosage) > 0
                                ? dispatch(
                                    formulaTotalChange(
                                      formula.formulaId,
                                      formula.formulaDosage -
                                        (isTotalChanged ? 0.5 : 1)
                                    )
                                  )
                                : dispatch(
                                    formulaTotalChange(formula.formulaId, 0)
                                  )
                            }
                          >
                            <FontAwesomeIcon icon={faCaretDown} />
                          </div>
                        </div>
                      </div>
                      grams
                    </div>
                  )}
                </td>
                <td></td>
                {!isRawType && <td></td>}
                {!isRawType && (
                  <td className="text-right">
                    {formula.formulaPrice.toLocaleString("en-US", {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}
                  </td>
                )}
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SuntenFormula;
